import React, {useEffect, useRef, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import Label from 'reactstrap/lib/Label';
import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import {getLanguage, t} from 'react-switch-lang';
import {
  createdepartment,
} from '../../../../services/departmentService';
import {useForm, FormProvider} from 'react-hook-form';
import {DepartmentScheme} from '../scheme';
import {yupResolver} from '@hookform/resolvers';
import {Toast} from '../../../../utils/sweetAlert';
import Swal from 'sweetalert2';
import "./Form.scss";
import InputText from '../../../../components/FormFields/InputText';
import SelectList from '../../../../components/FormFields/select/SelectList';
import {appModuleIdsOptions} from './departmentFormOptions';

const  AddDepartments = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const departmentTypeIdRef = useRef(null);
  const methods = useForm({
    resolver: yupResolver(DepartmentScheme),
  });
  const {handleSubmit, watch, errors, register, setValue} = methods;

  const submitForm = (data) => {
    setIsButtonDisabled(true);

    const dataToSubmit = {
      name: data.name,
      nameEn: data.nameEn,
      departmentTypeId: data?.departmentTypeId.value,
      parentId: data?.parentId?.value,
      userResponsibleId: data?.userResponsibleId?.value,
      sectorDirectorId: data?.sectorDirectorId?.value,
      userInChargeId: data?.userInChargeId?.value,
      userInChargeReplacementId: data?.userInChargeReplacementId?.value,
      userInChargeForExternalizationId: data?.userInChargeForExternalizationId?.value,
      userResponsibleForExternalizationId: data?.userResponsibleForExternalizationId?.value,
      deputyUserInChargeForExternalizationId: data?.deputyUserInChargeForExternalizationId?.value,
      appModuleIds: data?.appModuleIds?.map(item => item?.value),
    };

  createdepartment(dataToSubmit).then((res) => {
    if (res?.status === 201) {
      Toast.fire({
        title: t('departments.message.addSuccess', {
          entity: t('departments.department'),
        }),
        icon: 'success',
      });
      props.setRowChanged();
      props.toggleModal();
      setIsButtonDisabled(false)
    }
  setIsButtonDisabled(false);
  }).catch((err) => {
    if (err.response.data.detail === 'name') {
      Swal.fire({
        text: `${t('message.departmentExists')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    if (err.response.data.detail === 'name_en') {
      Swal.fire({
        text: `${t('message.departmentExists')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  })
  };

  useEffect(() => {
    register({name: "departmentTypeId", type: "custom"}, {required: true});
  }, []);

  useEffect(() => {
     if (errors.departmentTypeId) {
      const select = departmentTypeIdRef.current.select;
      select.focus();
    }
  }, []);

  const handleCancel = (e) => {
    e.preventDefault();
    props.toggleModal();
  };

  const nameValue = getLanguage() === "eng" ? "nameEn" : "name";
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="appModuleIds"> {t("departments.appModuleIds")}</Label>
            <SelectList
              name="appModuleIds"
              className="select pb-4"
              options={appModuleIdsOptions}
              placeholder={t('departments.placeholder.appModuleIds')}
              isClearable={false}
              errors={errors}
              isMulti={true}
              value={watch("appModuleIds") ?? []}
              onChange={(values) => {
                setValue("appModuleIds", values, { shouldValidate: true });
              }}
            />
            <Label for="name"> {t("departments.name")}</Label>
            <InputText
              type="text"
              id="name"
              name="name"
              className={
                "form-control " +
                (errors.name !== undefined ? "error-field" : "")
              }
              placeholder={t("departments.placeholder.name")}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="nameEn"> {t("departments.nameEn")}</Label>
            <InputText
              type="text"
              id="nameEn"
              name="nameEn"
              className={
                "form-control " +
                (errors.nameEn !== undefined ? "error-field" : "")
              }
              placeholder={t("departments.placeholder.nameEn")}
            />

          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="departmentTypeId"> {t("departments.departmentTypes")}</Label>
            <SelectInfinite
              api={`/department-types?sort=${nameValue}`}
              labelKey= {getLanguage() === "eng" ? "nameEn" : "name" }
              name="departmentTypeId"
              className={errors.departmentTypeId && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.departmentTypes").toLowerCase()}`}
              queryKeys={"name.contains"}
/>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="sectorDirector" className={"labelClass"}>
              {" "}
              {t("departments.sectorDirector")}
            </Label>
            <SelectInfinite
              api={`/users/sector-directors?sort=firstName`}
              name="sectorDirectorId"
              className={errors.sectorDirectorValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.placeholder.sectorDirector").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="parentId" className={"labelClass"}> {t("departments.departments")}
              <span className="optional">
                  {t('common.optional')}
                </span></Label>
            <SelectInfinite
              api={`/departments?sort=${nameValue}&active.equals=true`}
              labelKey= {getLanguage() === "eng" ? "nameEn" : "name" }
              name="parentId"
              className={errors.parentIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.placeholder.departments").toLowerCase()}`}
              queryKeys={getLanguage() === "eng" ? "nameEn.contains" : "name.contains" }
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userResponsibleId" className={"labelClass"}>
              {" "}
              {t("departments.responsibleUsers")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-responsible-users?sort=firstName`}
              name="userResponsibleId"
              className={errors.userResponsibleIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.responsibleUsers").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
       />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userInChargeId" className={"labelClass"}>
              {" "}
              {t("departments.inChargeUsers")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-in-charge-users?sort=firstName`}
              name="userInChargeId"
              className={errors.userInChargeIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.inChargeUsers").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
          />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userInChargeReplacementId" className={"labelClass"}>
              {" "}
              {t("departments.users")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-in-charge-users?sort=firstName`}
              name="userInChargeReplacementId"
              className={errors.userInChargeReplacementIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.placeholder.users").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userResponsibleForExternalizationId" className={"labelClass"}>
              {" "}
              {t("departments.userResponsibleForExternalization")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-responsible-users-for-externalization?sort=firstName`}
              name="userResponsibleForExternalizationId"
              className={errors.userResponsibleForExternalizationIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.userResponsibleForExternalization").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="userInChargeForExternalizationId" className={"labelClass"}>
              {" "}
              {t("departments.userInChargeForExternalization")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-users-in-charge-for-externalization?sort=firstName`}
              name="userInChargeForExternalizationId"
              className={errors.userInChargeForExternalizationIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.userInChargeForExternalization").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="deputyUserInChargeForExternalizationId" className={"labelClass"}>
              {" "}
              {t("departments.userInChargeReplacementForExternalization")}
              <span className="optional">
                  {t('common.optional')}
                </span>
            </Label>
            <SelectInfinite
              api={`/users/all-users-in-charge-for-externalization?sort=firstName`}
              name="deputyUserInChargeForExternalizationId"
              className={errors.deputyUserInChargeForExternalizationIdValidation && "error-field"}
              placeholder={`${t('departments.placeholder.select')} ${t("departments.userInChargeReplacementForExternalization").toLowerCase()}`}
              queryKeys={"firstName.contains"}
              labelKey={'fullName'}
            />
          </Col>
        </Row>
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button className="primary">
                {t("buttons.saveBtn")}
              </button>
            </div>
          </Col>
        </Row>
      </form>
    </FormProvider>
  );
}

export default AddDepartments;
